/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  listStyle: {
    margin: '20px 0px 0px 20px',
    fontFamily: "GTAR",
    '& li': {
      marginTop: '8px !important',
      listStyle: 'disc !important'
    }
  },
  childListStyle: {
    margin: '4px 0px 0px 20px',
    fontFamily: "GTAR",
    '& li': {
      marginTop: '2px !important',
      listStyle: 'circle !important'
    }
  },
  borderRight: {
    '& td': {
      borderRight: '1px solid #ddd !important'
    },
    '& th': {
      borderRight: '1px solid #ddd !important'
    },
    '& tr': {
      borderBottom: '1px solid #ddd !important'
    }
  },
  borderBottom: {
    height: '2px',
    width: '100%',
    borderBottom: '1px solid #ddd',
    marginBottom: '20px'
  }
});

export default useStyles;
